import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

function displayBreadcrumbLabel(label: string): string {
  if (label === 'Human') return 'HR';
  return label;
}

/** App-wide page chrome breadcrumbs — single size for every module/page. */
export function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav className="workspace-breadcrumbs" aria-label="Breadcrumb">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;

        return (
          <span key={`${item.label}-${i}`} className="workspace-breadcrumbs-item">
            {i > 0 && (
              <NavigateNextIcon
                className="workspace-breadcrumbs-sep"
                sx={{ fontSize: 16 }}
              />
            )}
            {item.to && !isLast ? (
              <Link to={item.to} className="workspace-breadcrumbs-link">
                <span className="workspace-breadcrumbs-label">
                  {displayBreadcrumbLabel(item.label)}
                </span>
              </Link>
            ) : (
              <span
                className={
                  isLast
                    ? "workspace-breadcrumbs-current"
                    : "workspace-breadcrumbs-link"
                }
              >
                <span className="workspace-breadcrumbs-label">
                  {displayBreadcrumbLabel(item.label)}
                </span>
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
